import ApiClient from '@services/ApiClient';

export default {
    findZone(lat, lng) {
        return ApiClient.get('/travel/berbus/zone', {
            params: {
                lat,
                lng,
            },
        });
    },

    search(params) {
        return ApiClient.get('/travel/berbus/search', {
            params,
        });
    },

    travelOptionPrices(id) {
        return ApiClient.get(`/travel/berbus/${id}/travel-option-prices`);
    },
};
